import {
    DirectoryAddressAddDto,
    DirectoryAddressModifyDto
} from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryAddress } from "@/ContactDirectory/Models/DirectoryAddress";

export class DirectoryAddressMapper {
    public static toAddDto(address: DirectoryAddress): DirectoryAddressAddDto {
        return {
            streetAddress: address.streetAddress,
            city: address.city,
            postalCode: address.postalCode,
            countryId: address.countryId,
            stateId: address.stateId
        };
    }

    public static toModifyDto(address: DirectoryAddress): DirectoryAddressModifyDto {
        return {
            id: address.id,
            streetAddress: address.streetAddress,
            city: address.city,
            postalCode: address.postalCode,
            countryId: address.countryId,
            stateId: address.stateId
        };
    }
}
